"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryPickupRouteBreadcrumbUpdate = exports.DeliveryPickupRouteBreadcrumbCreate = exports.DeliveryPickupRouteBreadcrumbQuery = exports.DeliveryPickupRouteBreadcrumbTransport = exports.DeliveryPickupRouteBreadcrumb = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const DeliveryPickupRouteEvent_1 = require("./DeliveryPickupRouteEvent");
exports.DeliveryPickupRouteBreadcrumb = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    deliveryPickupRouteID: typebox_1.Type.String({ format: 'uuid' }),
    deliveryPickupPlannedStopID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    latitude: typebox_1.Type.Number(),
    longitude: typebox_1.Type.Number(),
    timestamp: typebox_1.Type.String({ format: 'date-time' }),
    deliveryPickupRouteEvent: typebox_1.Type.Optional(DeliveryPickupRouteEvent_1.DeliveryPickupRouteEvent),
});
exports.DeliveryPickupRouteBreadcrumbTransport = exports.DeliveryPickupRouteBreadcrumb;
exports.DeliveryPickupRouteBreadcrumbQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        customerID: typebox_1.Type.String({ format: 'uuid' }),
        deliveryPickupRouteID: typebox_1.Type.String({ format: 'uuid' }),
        hasPlannedStop: typebox_1.Type.Boolean(),
        plannedStopID: typebox_1.Type.String({ format: 'uuid' }),
        latitudeAbove: typebox_1.Type.Number(),
        latitudeBelow: typebox_1.Type.Number(),
        longitudeAbove: typebox_1.Type.Number(),
        longitudeBelow: typebox_1.Type.Number(),
        timestampBefore: typebox_1.Type.String({ format: 'date-time' }),
        timestampAfter: typebox_1.Type.String({ format: 'date-time' }),
        hasEvent: typebox_1.Type.Boolean(),
        deliveryPickupRouteEventID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
exports.DeliveryPickupRouteBreadcrumbCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.DeliveryPickupRouteBreadcrumb, ['id', 'haulerID', 'deliveryPickupRouteEvent']),
    typebox_1.Type.Object({
        deliveryPickupRouteEvent: typebox_1.Type.Optional(DeliveryPickupRouteEvent_1.DeliveryPickupRouteEventCreate),
    }),
]);
exports.DeliveryPickupRouteBreadcrumbUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.DeliveryPickupRouteBreadcrumb, [
    'id',
    'haulerID',
    'deliveryPickupPlannedStopID',
    'deliveryPickupRouteEvent',
]));
//# sourceMappingURL=DeliveryPickupRouteBreadcrumb.js.map